import './polyfills'
import { ViteReactSSG } from 'vite-react-ssg'
import { routes } from './App'
import './i18n'
import './index.css'

// Local Fonts
import '@fontsource/inter/300.css'
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/nunito/300.css'
import '@fontsource/nunito/400.css'
import '@fontsource/nunito/500.css'
import '@fontsource/nunito/600.css'
import '@fontsource/nunito/700.css'
import '@fontsource/nunito/800.css'

export const createRoot = ViteReactSSG({ routes })
